import { render, staticRenderFns } from "./booking-event.vue?vue&type=template&id=252816e8&scoped=true&"
import script from "./booking-event.ts?vue&type=script&lang=ts&"
export * from "./booking-event.ts?vue&type=script&lang=ts&"
import style0 from "./booking-event.scss?vue&type=style&index=0&id=252816e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252816e8",
  null
  
)

export default component.exports